import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "footer-accordion" }
const _hoisted_2 = { class: "footer-accordion-item" }
const _hoisted_3 = { class: "footer-accordion-content" }
const _hoisted_4 = {
  key: 0,
  href: "/safer-gambling"
}
const _hoisted_5 = {
  key: 0,
  class: "footer-accordion-item"
}
const _hoisted_6 = { class: "footer-accordion-item" }
const _hoisted_7 = { class: "footer-accordion-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("button", {
        id: "footer-accordion-button-1",
        type: "button",
        "aria-expanded": "false"
      }, [
        _createElementVNode("span", { class: "footer-accordion-title" }, "Here To Help"),
        _createElementVNode("span", {
          class: "icon",
          "aria-hidden": "true"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("a", { href: "/help-centre" }, "Help Centre", -1)),
        _createElementVNode("a", {
          href: "#",
          type: "submit",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFAQClick && _ctx.handleFAQClick(...args)))
        }, "FAQs"),
        (_ctx.features.showBettingLogos)
          ? (_openBlock(), _createElementBlock("a", _hoisted_4, "Safer Gambling"))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.features.showHowItWorks)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[4] || (_cache[4] = [
          _createStaticVNode("<button id=\"footer-accordion-button-2\" type=\"button\" aria-expanded=\"false\" data-v-49f5da3f><span class=\"footer-accordion-title\" data-v-49f5da3f>How it Works</span><span class=\"icon\" aria-hidden=\"true\" data-v-49f5da3f></span></button><div class=\"footer-accordion-content\" data-v-49f5da3f><a href=\"/page/howtoshoponline\" data-v-49f5da3f>How To Shop Online</a></div>", 2)
        ]))]))
      : _createCommentVNode("", true),
    _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"footer-accordion-item\" data-v-49f5da3f><button id=\"footer-accordion-button-3\" type=\"button\" aria-expanded=\"false\" data-v-49f5da3f><span class=\"footer-accordion-title\" data-v-49f5da3f>Get Involved</span><span class=\"icon\" aria-hidden=\"true\" data-v-49f5da3f></span></button><div class=\"footer-accordion-content\" data-v-49f5da3f><a href=\"https://careers.rewards4group.com/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-49f5da3f>Careers</a></div></div>", 1)),
    _createElementVNode("div", _hoisted_6, [
      _cache[7] || (_cache[7] = _createElementVNode("button", {
        id: "footer-accordion-button-4",
        type: "button",
        "aria-expanded": "false"
      }, [
        _createElementVNode("span", { class: "footer-accordion-title" }, "Legal Stuff"),
        _createElementVNode("span", {
          class: "icon",
          "aria-hidden": "true"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        _cache[5] || (_cache[5] = _createElementVNode("a", { href: "/terms" }, "Member Agreement", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("a", { href: "/privacycentre" }, "Privacy Policy", -1)),
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCookieSettings && _ctx.openCookieSettings(...args)), ["prevent"]))
        }, "Cookie Policy")
      ])
    ])
  ]))
}